/**
 * Every domain error code this build knows, declared once.
 *
 * The repository writes these codes and the screens read them from another layer, so a code spelled
 * out on both sides keeps compiling after a rename and silently stops matching. Pointing both sides
 * at this object is what turns that into a compile error.
 *
 * It is an object and not the array this domain uses for its other closed sets, because the callers
 * need to name one code, not to iterate the list.
 */
export const IDENTITY_ERROR_CODES = {
  LINK_EXPIRED: 'LINK_EXPIRED',
  LINK_COMPLETED: 'LINK_COMPLETED',
  LINK_INVALID: 'LINK_INVALID',
  PASSWORD_POLICY: 'PASSWORD_POLICY',
  CURRENT_PASSWORD_REQUIRED: 'CURRENT_PASSWORD_REQUIRED',
  CURRENT_PASSWORD_INVALID: 'CURRENT_PASSWORD_INVALID',
  EMAIL_IN_USE: 'EMAIL_IN_USE',
  EMAIL_INVALID: 'EMAIL_INVALID',
  PHONE_INVALID: 'PHONE_INVALID',
  LINK_SEND_RATE_LIMITED: 'LINK_SEND_RATE_LIMITED',
  RECOVERY_RATE_LIMITED: 'RECOVERY_RATE_LIMITED',
  EXPIRED_TOKEN: 'EXPIRED_TOKEN',
  VERIFICATION_SUPERSEDED: 'VERIFICATION_SUPERSEDED',
} as const;

/**
 * A code of the catalog.
 *
 * Most codes have an inline text under `errors` in the translations. `EXPIRED_TOKEN` does not: it
 * sends the user to the session expired screen instead of rendering a message under a field.
 */
export type IdentityErrorCode = typeof IDENTITY_ERROR_CODES[keyof typeof IDENTITY_ERROR_CODES];
